import { createSlice } from '@reduxjs/toolkit'
import { fetchHoroscope } from '../../../application/usecases/fetchHoroscope.ts'

interface HoroscopeState {
  data: any | null
  loading: boolean
  error: string | null
}

const initialState: HoroscopeState = {
  data: null,
  loading: false,
  error: null,
}

const horoscopeSlice = createSlice({
  name: 'horoscope',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHoroscope.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchHoroscope.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload
      })
      .addCase(fetchHoroscope.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Error desconocido'
      })
  },
})

export default horoscopeSlice.reducer
